module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "detail-msg"
    }
  }, [_c('timeline', _vm._l((_vm.auditData), function(item, key) {
    return _c('timeline-item', {
      key: key
    }, [_c('h4', {
      class: [item.stepStatus == 1 ? 'current-node' : '']
    }, [_vm._v(" " + _vm._s(item.stepName) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "timeline-part"
    }, [_c('h4', [_vm._v("\n          " + _vm._s(item.operators[0]) + " " + _vm._s(item.opinion) + " " + _vm._s(item.workEndDate) + "\n        ")]), _vm._v(" "), (item.works.length > 0) ? _c('p') : _vm._e(), _vm._l((item.works), function(childItem, key) {
      return _c('h5', [_c('p', [_vm._v("\n          " + _vm._s(childItem.operators[0]) + " " + _vm._s(childItem.opinion) + " " + _vm._s(childItem.workEndDate) + "\n        ")])])
    }), _vm._v(" "), _c('p')], 2)])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3251b0c5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/Msg.vue
// module id = 3Iur
// module chunks = 0